import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store';
import fetchAPI from '../../../common/fetchAPI'
import { EmployeeTimeOffStateClass } from './interfaces/employeeClass';
import { formatNumberCustomoriginalapiv2 } from '../../../common/timeLiveFunction';
import { log } from 'console';

const initialState: EmployeeTimeOffStateClass = {
    isLoading: true,
    isCanvasLoading: false,
    isCanvasOpen: false,
    status: 'idle',
    accountEmployeeId: 0,
    isReload: false,
    ////////
    employeeTimeOffList: [],
    employeeTimeOffListForEdit: [],
    //pagination
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isShowGrid: false
}

interface IThunkApi {
    state: {
        globalState: any;
        employeeTimeOff: EmployeeTimeOffStateClass;
    }
}

export const getAccountEmployeeTimeOffByAccountEmployeeId = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/V2/getAccountEmployeeTimeOffByAccountEmployeeId',
        async (arg, thunkApi) => {
            //const { accountEmployeeId } = thunkApi.getState().employeeTimeOff;
            const { cultureInfoName } = thunkApi.getState().globalState
            const response = await fetchAPI(`api/V2/Employees/AccountEmployeeTimeOffByAccountEmployeeId/${arg}`, `Get`, '', true, "");
            const json = await response.json();
            // return json;
            return { res: json, cultureInfoName };
        }
    )

	// export const getAccountEmployeeTimeOffByAccountEmployeeId =
	//   createAsyncThunk<any, { AccountEmployeeId: number; cultureInfoName: string }, IThunkApi>(
	// 	'Employees/V2/getAccountEmployeeTimeOffByAccountEmployeeId',
	// 	async (arg, thunkApi) => {
	// 	  const { AccountEmployeeId, cultureInfoName } = arg;

	// 	  const response = await fetchAPI(
	// 		`api/V2/Employees/AccountEmployeeTimeOffByAccountEmployeeId/${AccountEmployeeId}?cultureInfoName=${cultureInfoName}`,
	// 		'GET',
	// 		'',
	// 		true,
	// 		''
	// 	  );

	// 	  const json = await response.json();
	// 	  return json;
	// 	}
	//   );

export const UpdateTimeOffStatus = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/V2/UpdateTimeOffStatus',
        async (arg, thunkApi) => {
            const { employeeTimeOffList, IsShowTimeOffInDays, IsTimeOffStatusEditMode, EmployeeNameWithCode } = arg;
            const response = await fetchAPI('api/v2/Employees/UpdateTimeOffStatus/' + IsShowTimeOffInDays + '/' + IsTimeOffStatusEditMode + '/' + EmployeeNameWithCode, 'PUT', employeeTimeOffList, true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

export const ResetTimeOffPolicy = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/V2/ResetTimeOffPolicy',
        async (arg, thunkApi) => {
            const { employeeNameWithCode, accountEmployeeId} = arg;
            const response = await fetchAPI('api/v2/Employees/ResetTimeOffPolicy/' + arg.AccountEmployeeId + '/' + arg.employeeNameWithCode, 'PUT', "", true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

export const employeeTimeOffSlice = createSlice({
    name: 'employeeTimeOff',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.employeeTimeOffListForEdit = [];
            state.isReload = true;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageNo = action.payload.pageNumber;
            state.startRec = action.payload.start;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
        },
        checkedState: (state, action) => {
            const currentindex = state.employeeTimeOffList.findIndex((item) => item.AccountEmployeeTimeOffId == action.payload);
            const newArray = [...state.employeeTimeOffList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.employeeTimeOffList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.employeeTimeOffList.findIndex((item) => item.AccountEmployeeTimeOffId == action.payload);
            const newArray = [...state.employeeTimeOffList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.employeeTimeOffList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.employeeTimeOffList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.employeeTimeOffList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.employeeTimeOffList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.employeeTimeOffList = newArray;
        },
        setEditState: (state, action) => {
            const { AccountEmployeeTimeOffId, value, id } = action.payload;
            const currentindex = state.employeeTimeOffList.findIndex((item) => item.AccountEmployeeTimeOffId == AccountEmployeeTimeOffId);
            const newArray = [...state.employeeTimeOffList];
            newArray[currentindex] = { ...newArray[currentindex], [id]: value };
            state.employeeTimeOffListForEdit[currentindex] = newArray[currentindex];
            state.employeeTimeOffList = newArray;
        },
        setLastEarnedDateState: (state, action) => {
            const { AccountEmployeeTimeOffId, value } = action.payload;
            const currentindex = state.employeeTimeOffList.findIndex((item) => item.AccountEmployeeTimeOffId == AccountEmployeeTimeOffId);
            const newArray = [...state.employeeTimeOffList];
            newArray[currentindex] = { ...newArray[currentindex], LastEarnedDate: value };
            state.employeeTimeOffListForEdit[currentindex] = newArray[currentindex];
            state.employeeTimeOffList = newArray;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeeTimeOffByAccountEmployeeId.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTimeOffByAccountEmployeeId.fulfilled, (state, action) => {

                const { cultureInfoName, res } = action.payload as any;
                state.status = 'idle';
                state.isLoading = false;

                if (!Array.isArray(res?.Data) || res.Data.length === 0) {
                    state.employeeTimeOffList = [];
                    return;
                }

                state.employeeTimeOffList = res.Data.map((item: any) => ({
                    ...item,
                    isSelected: 0,
                    Earned: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.Earned,
                        2
                    ),
                    Available: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.Available,
                        2
                    ),
                    AvailableDay: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.AvailableDay,
                        2
                    ),
                    EarnedDay: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.EarnedDay,
                        2
                    ),
                    Consume: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.Consume,
                        2
                    ),
                    ConsumeDay: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.ConsumeDay,
                        2
                    ),
                    CarryForward: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.CarryForward,
                        2
                    ),
                    CarryForwardDay: formatNumberCustomoriginalapiv2(
                        cultureInfoName || "en-US",
                        item.CarryForwardDay,
                        2
                    )
                }));

            })
            .addCase(getAccountEmployeeTimeOffByAccountEmployeeId.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(UpdateTimeOffStatus.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateTimeOffStatus.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(UpdateTimeOffStatus.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(ResetTimeOffPolicy.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ResetTimeOffPolicy.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(ResetTimeOffPolicy.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    updatePagination,
    updateSearchPagination,
    updateIsLoading,
    updateIsCanvasLoading,
    checkedAllState,
    unCheckedAllState,
    checkedState,
    unCheckedState,
    setEditState,
    setLastEarnedDateState,
    resetSelectedRecordObjectInState
} = employeeTimeOffSlice.actions

export const EmployeeTimeOffState = (state: RootState) => state.employeeTimeOff
export default employeeTimeOffSlice.reducer